import { Typography } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'

import useStyles from './styles/MonitoringReserveTable.skeleton.styles'

type MonitoringReserveTableSkeletonProps = {}

export default function MonitoringReserveTableSkeleton({}: MonitoringReserveTableSkeletonProps) {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      {Array(14)
        .fill(' ')
        .map(() => (
          <Typography
            variant="body1"
            className={[
              classes.skeletonContainer,
              4 % 2 === 0 && classes.skeletonContainerEven
            ].join(' ')}>
            <Skeleton animation="wave" className={classes.skeleton} />
          </Typography>
        ))}
    </div>
  )
}
